<template lang="pug">
.gu24__search-results
  .gu24__search-results__list
    template(v-if="results.length > 0")
      template(v-for="result in results")
        template(v-if="result.use && result.use.nuxt")
          a.gu24__search-results__item(:href="result.use.url",
                                       @click.prevent="routing(result.use.url, 'route')")
            .gu24__search-results__item__name {{ result.name }}
            .gu24__search-results__item__breadcrumbs {{ result.sub }}
        template(v-else)
          a.gu24__search-results__item(:href="result.use.url",
                                       @click.prevent="routing(result.use.url, 'href')")
            .gu24__search-results__item__name {{ result.name }}
            .gu24__search-results__item__breadcrumbs {{ result.sub }}
    template(v-else)
      .gu24__search-results__item.gu24__search-results__item_no-found
        .gu24__search-results__item__breadcrumbs {{$t('msgs.nothingFound')}}
</template>

<script>
export default {
  name: 'SearchResults',
  props: {
    results: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  methods: {
    routing(url, type) {
      // emit for hide search str
      this.$emit('clicked');

      // routing
      if (type === 'href') {
        window.open(url, '_blank');
      }
      if (type === 'route') {
        window.open(url, '_blank');
      }
    },
    urlConvert(resultName) {
      if ((resultName.use.url.name.slice(7,14)).includes('objects')) return 'objects';
      if ((resultName.use.url.name.slice(7,14)).includes('events')) return 'events';
      if ((resultName.use.url.name.slice(7,14)).includes('videos')) return 'videos';
      if ((resultName.use.url.name.slice(7,14)).includes('ames')) return 'names';
      if ((resultName.use.url.name.slice(7,14)).includes('ours')) return 'tours';
    },
    urlType(resultType) {
      if (resultType.use.url.params.event) return resultType.use.url.params.event;
      if (resultType.use.url.params.object) return resultType.use.url.params.object;
    },
    
  },
  mounted() {
    console.log('result', this.results)
  },
};
</script>

<style lang="scss">
.gu24__search-results {
  z-index: 6;
  position: absolute;
  transform: translateY(100%);
  bottom: 0;
  left: 0; right: 0;
  padding: 20 / 16 + rem 10 / 16 + rem 20 / 16 + rem 0;
  box-shadow: 0 1 / 16 + rem 10 / 16 + rem 0 rgba(0, 0, 0, 0.3);
  background: #fff;
  overflow: hidden;
  &__list {
    max-height: 216 / 16 + rem;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4 / 16 + rem;
    }
    &::-webkit-scrollbar-track {
      background: #f4f4f4;
      border-radius: 2 / 16 + rem;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 2 / 16 + rem;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #aaa;
    }
  }
  &__item {
    font-family: 'Montserrat', sans-serif;
    cursor: pointer;
    text-decoration: none;
    transition: all .25s ease;
    display: block;
    padding: 10 / 16 + rem 30 / 16 + rem;
    &__name {
      font-size: 14 / 16 + rem;
      font-weight: 600;
      margin-bottom: 7 / 16 + rem;
    }
    &__breadcrumbs {
      font-size: 13 / 16 + rem;
      color: #666;
    }
    &__name, &__breadcrumbs { // hide other text
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
    }
    &:hover {
      text-decoration: underline;
    }
    &_no-found {
      font-size: 13 / 16 + rem;
      color: #666;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
